/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StockGoodsListResVo } from './StockGoodsListResVo';
import {
    StockGoodsListResVoFromJSON,
    StockGoodsListResVoFromJSONTyped,
    StockGoodsListResVoToJSON,
    StockGoodsListResVoToJSONTyped,
} from './StockGoodsListResVo';

/**
 * 
 * @export
 * @interface PageDataStockGoodsListResVo
 */
export interface PageDataStockGoodsListResVo {
    /**
     * 当前页
     * @type {number}
     * @memberof PageDataStockGoodsListResVo
     */
    currentPage?: number;
    /**
     * 总页数
     * @type {number}
     * @memberof PageDataStockGoodsListResVo
     */
    totalPage?: number;
    /**
     * 总记录数
     * @type {number}
     * @memberof PageDataStockGoodsListResVo
     */
    totalRecord?: number;
    /**
     * 列表内容
     * @type {Array<StockGoodsListResVo>}
     * @memberof PageDataStockGoodsListResVo
     */
    records?: Array<StockGoodsListResVo>;
}

/**
 * Check if a given object implements the PageDataStockGoodsListResVo interface.
 */
export function instanceOfPageDataStockGoodsListResVo(value: object): value is PageDataStockGoodsListResVo {
    return true;
}

export function PageDataStockGoodsListResVoFromJSON(json: any): PageDataStockGoodsListResVo {
    return PageDataStockGoodsListResVoFromJSONTyped(json, false);
}

export function PageDataStockGoodsListResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageDataStockGoodsListResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalPage': json['totalPage'] == null ? undefined : json['totalPage'],
        'totalRecord': json['totalRecord'] == null ? undefined : json['totalRecord'],
        'records': json['records'] == null ? undefined : ((json['records'] as Array<any>).map(StockGoodsListResVoFromJSON)),
    };
}

export function PageDataStockGoodsListResVoToJSON(json: any): PageDataStockGoodsListResVo {
    return PageDataStockGoodsListResVoToJSONTyped(json, false);
}

export function PageDataStockGoodsListResVoToJSONTyped(value?: PageDataStockGoodsListResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentPage': value['currentPage'],
        'totalPage': value['totalPage'],
        'totalRecord': value['totalRecord'],
        'records': value['records'] == null ? undefined : ((value['records'] as Array<any>).map(StockGoodsListResVoToJSON)),
    };
}

